"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = require("prop-types");
const intl_1 = require("@kyruus/intl");
const provider_components_1 = require("@kyruus/provider-components");
const Tracking_1 = require("../../lib/constants/Tracking");
const utils_1 = require("../../lib/utils");
const styles_1 = require("./styles");
const messages_1 = __importDefault(require("../../lib/messages"));
const RescheduleComponent = ({ appointment, createRescheduleLink, locationId, locations, provider, providerId, searchProvidersLink, track }) => {
    const { patientRelationship, patientPurpose, startDateTime } = appointment;
    // Sidebar adapter
    const appointmentQuery = {
        patientRel: patientRelationship,
        purpose: {
            name: patientPurpose
        }
    };
    const selectedAppointment = {
        start_datetime: startDateTime,
        location_id: locationId
    };
    const handleRescheduleButtonClick = () => {
        track(Tracking_1.userEvents.CLICK_RESCHEDULE_CTA);
    };
    const handleNewSearchButtonClick = () => {
        track(Tracking_1.userEvents.CLICK_NEW_SEARCH_CTA);
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(styles_1.Section, null,
            react_1.default.createElement(styles_1.UserMDStyled, { "aria-hidden": "true" }),
            react_1.default.createElement("div", null,
                react_1.default.createElement(styles_1.SectionHeading, null, (0, utils_1.hasProvider)(provider) ? (react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.rescheduleHeading, { values: {
                        provider_name: (0, provider_components_1.getProviderDisplayName)(provider)
                    } }))) : (react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.rescheduleUnnamedHeading)))),
                (0, utils_1.hasProvider)(provider) ? (react_1.default.createElement(provider_components_1.ProviderSidebar, { provider: provider, locations: locations, appointmentQuery: appointmentQuery, selectedAppointment: selectedAppointment, track: track, showApptTime: false, showSchedulingHelpBanner: false },
                    react_1.default.createElement(styles_1.SideBarButton, { "data-testid": "reschedule-sidebar-deep-link-button", mode: "primary", onClick: handleRescheduleButtonClick, href: createRescheduleLink(providerId, patientRelationship, patientPurpose) },
                        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.rescheduleLinkText))))) : (react_1.default.createElement(styles_1.ButtonContainer, null,
                    react_1.default.createElement(styles_1.Button, { "data-testid": "reschedule-deep-link-button", mode: "primary", onClick: handleRescheduleButtonClick, href: createRescheduleLink(providerId, patientRelationship, patientPurpose) },
                        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.rescheduleLinkText))))))),
        react_1.default.createElement(styles_1.Section, null,
            react_1.default.createElement(styles_1.SearchStyled, { "aria-hidden": "true" }),
            react_1.default.createElement("div", null,
                react_1.default.createElement(styles_1.SectionHeading, null,
                    react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.newSearchHeading))),
                react_1.default.createElement(styles_1.ButtonContainer, null,
                    react_1.default.createElement(styles_1.Button, { "data-testid": "reschedule-search-button", mode: "ghost", onClick: handleNewSearchButtonClick, href: searchProvidersLink },
                        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.newSearchLinkText))))))));
};
RescheduleComponent.propTypes = {
    /**
     * The appointment object
     */
    appointment: (0, prop_types_1.shape)({
        patientPurpose: prop_types_1.string.isRequired,
        patientRelationship: prop_types_1.string.isRequired,
        startDateTime: prop_types_1.string.isRequired
    }).isRequired,
    /**
     * Callback that takes a providerId, patientRelationship, and patientPurpose and returns a deeplinked directbook URL for rescheduling an appointment
     * @callback createRescheduleLink
     * @param {number} providerId
     * @param {string} patientRelationship
     * @param {string} patientPurpose
     */
    createRescheduleLink: prop_types_1.func.isRequired,
    /**
     * The ID of the location assoicated with the appointment
     */
    locationId: prop_types_1.number.isRequired,
    /**
     * An array of the providers locations
     */
    locations: (0, prop_types_1.arrayOf)(prop_types_1.object).isRequired,
    /**
     * The provider object associated with the appointment if it was fetched
     */
    provider: prop_types_1.object,
    /**
     * The ID of the provider associated with the appointment
     */
    providerId: prop_types_1.number.isRequired,
    /**
     * URL link for the `Search Providers` button.
     */
    searchProvidersLink: prop_types_1.string.isRequired,
    /**
     * Callback triggered for tracking
     * @callback track
     * @param {string} eventName
     * @param {object} eventData
     */
    track: prop_types_1.func.isRequired
};
exports.default = RescheduleComponent;
//# sourceMappingURL=RescheduleComponent.js.map